import { useState, useEffect } from 'react';
import { FetchRequestTypes, useFetch } from '../../../hooks/useFetch';
import { ShipsData, ShipsDataItem } from '../interfaces/arrivalsDepartures.interfaces';

export const useShipsData = (imo: String | null, startLoad: boolean) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [shipData, setShipData] = useState<ShipsDataItem | null>(null);

  const { data, loading, error } = useFetch(dataUrl, FetchRequestTypes.GET);

  useEffect(() => {
    if (imo && startLoad) {
      if (shipData?.imo !== imo) {
        setDataUrl(`/api-aad/web-backend/v1/ship?imo=${imo}`);
      }
    }
  }, [imo, startLoad]);

  useEffect(() => {
    if (data) {
      const loadedData = data as ShipsData;
      setShipData(loadedData.items[0]);
    }
  }, [data]);

  useEffect(() => {}, [loading, error]);

  return { shipData, loading, error };
};

